import {createReducer} from '@reduxjs/toolkit';
import {
    getAllGlobalCriteria,
    addGlobalCriteria,
    editGlobalCriteria,
    deleteGlobalCriteria,
    getMarkTemplatesByProjectId,
    deleteMarkCriteria
} from '../actions';
import {mapMarkTemplates} from '../../utils';
import {MarkCriteria} from '../../../../dto/MarkTemplateDto';
import {GlobalCriteriaDto} from '../../../../dto/GlobalCriteriaDto';

type InitialState = {
    isFetching: boolean;
    global: GlobalCriteriaDto[];
    project: {
        markCriterias: MarkCriteria[];
        positionsWithIds: {
            markCriteriaId: number;
            positions: {
                position: string;
                id: number;
            }[];
        }[];
    };
};

const initialState: InitialState = {
    isFetching: false,
    global: [],
    project: {
        markCriterias: [],
        positionsWithIds: []
    }
};

export const reasons = createReducer(initialState, (builder) =>
    builder
        .addCase(getAllGlobalCriteria.fulfilled, (state, action) => ({...state, global: action.payload}))
        .addCase(addGlobalCriteria.fulfilled, (state, action) => ({
            ...state,
            global: state.global.concat(action.payload)
        }))
        .addCase(editGlobalCriteria.fulfilled, (state, action) => ({
            ...state,
            global: state.global.map((el) => {
                if (el.id === action.payload.id) {
                    return action.payload;
                }
                return el;
            })
        }))
        .addCase(deleteGlobalCriteria.fulfilled, (state, action) => ({
            ...state,
            global: state.global.map((el) => {
                if (el.id === action.payload) {
                    return {...el, active: false};
                } else {
                    return el;
                }
            })
        }))
        .addCase(getMarkTemplatesByProjectId.fulfilled, (state, action) => ({
            ...state,
            project: mapMarkTemplates(action.payload)
        }))
        .addCase(deleteMarkCriteria.fulfilled, (state, action) => ({
            ...state,
            project: {
                ...state.project,
                markCriterias: state.project.markCriterias.map((el) => {
                    if (el.id === action.payload) {
                        return {...el, active: false};
                    } else {
                        return el;
                    }
                })
            }
        }))
);
